import { FC } from "react";
import { Descriptions } from "antd";
import type { DescriptionsProps } from "antd";
import './DetailsOverview.css'
interface DetailsOverviewProps {
  data: Record<string, string | number | boolean | JSX.Element>;
  title?: string;
  className?: string // Optional label style prop
}

const DetailsOverview: FC<DetailsOverviewProps> = ({ data, title, className }) => {
  // Convert the object into Descriptions-compatible items
  const items: DescriptionsProps["items"] = Object.entries(data).map(([key, value], index) => ({
    key: `${index}`, // Use the index as the unique key
    label: key, // Use the object key as the label
    children: value, // Use the value directly
  }));

  return (
    <div className="details-overview-main-wrapper">
    <Descriptions
      title={title}
      layout="vertical"
      size="small"
      bordered
      column={{ xxl: 4, xl: 4, lg: 4, md: 4, sm: 3, xs: 3 }}
      className={className} 
    >
      {items.map((item) => (
        <Descriptions.Item key={item.key} label={item.label}>
          {item.children}
        </Descriptions.Item>
      ))}
    </Descriptions>
    </div>
  );
};

export default DetailsOverview;
